import * as API from '@siloreal:shared:api';

const SILOBAG_HARVEST_LIST_ENDPOINT = '/harvests';

export type SilobagHarvestListServiceContract = {
  signal?: AbortSignal;
};

export async function listSilobagHarvestsService(
  contract: SilobagHarvestListServiceContract = {}
): Promise<SilobagHarvestListResponse> {
  const { data } = await API.http.fetch.get<SilobagHarvestListResponse>(SILOBAG_HARVEST_LIST_ENDPOINT, {
    signal: contract.signal,
  });

  return data;
}

export type SilobagHarvestListResponse = SilobagHarvestListItem[];

export type SilobagHarvestListItem = {
  id: number;
  name: string;
  active: boolean;
  created_at: Date | string;
  updated_at: Date | string | null;
};
